export function scenarioTags(scenario) {
  return scenario.tags.join(", ");
}
